import { render } from "./TopFlows.vue?vue&type=template&id=1f893f30"
import script from "./TopFlows.vue?vue&type=script&lang=js"
export * from "./TopFlows.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__